import { getField, updateField } from "vuex-map-fields";
// (RBF0605P60.dwkDstcd, RBF0605P60.pengagTrsaccYmd, RBF0605P60.trsaccCyclUnitDstcd, RBF0605P60.trsaccCyclUnitCnt)
const getDefaultState = () => {
  return {
    data: "",
    drwotAcno: {}, //출금계좌정보
    mnrcvAcno: {}, //입금계좌정보
    autoTrasInfo: {
      prcssDstcd: "",
      acno: "", //계좌번호
      cncycd: "", //통화코드
      trsaccAmt: "", //이체금액
      trsaccEndYmd: "", //이체종료년월일
      trsaccStartYmd: "", //이체시작년월일
      trsaccCyclUnitDstcd: "", //이체주기단위구분코드
      trsaccCyclUnitCnt: "", //이체주기단위수
      holdyTrsaccDstcd: "", //휴일이체구분코드
      draweAcno: "", //수취인계좌번호
      serno: "", //수취인계좌일련번호
      mnrcvAcnObaobDstic: "", //수취인계좌당타행구분
      draweRefCtnt1: "", //수취인참조내용1
      draweRefCtnt2: "", //수취인참조내용2
      draweRefCtnt3: "", //수취인참조내용3
      trsaccApctRefCtnt1: "", //이체신청인참조내용1(송금메모)
      password: {}, //계좌비밀번호
      transFreq: "", //이체주기(selectbox)
      holiTrans: "", //휴일인경우(selectbox)
      nxtrmPbhdayInclsnTrsaccYmd: "" // 차기이체년월일
    },
    RBF0605P60: {}, //	자동이체등록 예비거래 결과
    resData: {}, //	자동이체등록 본거래 결과
    isStpulCfm: false,
  };
};

const autoTrsaccInfoInpt = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    actAllStateReset({ commit }) {
      commit("resetState");
    },
  },
};

export default autoTrsaccInfoInpt;
